import { parseFetchAllRequest as parseAllRequest } from 'containers/App/modules/entities/users/users.parsers';

// Convert generic grid payload into SearchRequestV2-compatible body for the commands search API.
// The commands API uses timestamp: { from, to } as a combined range filter,
// while grid stores timestampAfter / timestampBefore as separate keys.
export const parseFetchAllRequest = (payload) => {
	if (!payload || !payload.pagination) return { page: 0, limit: 50, filter: {}, sort: [{ prop: 'timestamp', order: 'DESC' }] };
	const base = parseAllRequest(payload) || {};
	const { filter: filterArray, sort, limit, page, search } = base;

	const filter = {};
	const timestampRange = {};

	(filterArray || []).forEach((f) => {
		if (!f || !f.prop) return;
		const values = Array.isArray(f.values) ? f.values : (f.values != null ? [f.values] : []);
		if (values.length === 0) return;

		if (f.prop === 'timestampAfter') {
			timestampRange.from = values[0];
		} else if (f.prop === 'timestampBefore') {
			timestampRange.to = values[0];
		} else if (f.prop.endsWith('After')) {
			filter[f.prop] = { from: values[0] };
		} else if (f.prop.endsWith('Before')) {
			filter[f.prop] = { to: values[0] };
		} else {
			if (values.length === 1) {
				filter[f.prop] = { eq: values[0] };
			} else {
				filter[f.prop] = { in: values };
			}
		}
	});

	if (timestampRange.from || timestampRange.to) {
		filter.timestamp = timestampRange;
	}

	const sortList = (sort || []).map((s) => ({
		prop: s.prop || s.key || s.field,
		order: (s.order || 'ASC').toUpperCase(),
	}));

	return {
		filter,
		freeTextSearch: search || undefined,
		sort: sortList.length > 0 ? sortList : [{ prop: 'timestamp', order: 'DESC' }],
		limit: limit ?? 50,
		page: page ?? 0,
	};
};

export const parseFetchAllSuccess = (responseData) => {
	return responseData.data || [];
};

export const parseMetadata = (responseData) => {
	return responseData.metadata;
};
